export default __webpack_public_path__ + "a1e7fdee043eeef1c66fb5ee762840d5.svg";